import {meetActionTypes} from '../action/action';

interface VirtualBGSate {
  image: string;
  dupImage:string;
  bodyPix: any;
  tflite: any;
  imgIndex: number;
  dupImgIndex: number;
  viewMode: string;
  previousView:string
  peerConCheck:boolean;
}
const initialState = {
  peerConCheck:false,
  image:"",
  bodyPix:"",
  tflite: "",
  imgIndex:0,
  dupImage:"",
  dupImgIndex:0,
  viewMode: "Active Speaker",
  previousView:"Active Speaker"
};

export const VirtualBG = (state:VirtualBGSate  = initialState, action: any) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
  case meetActionTypes.UPDATE_VIRTUAL_BG:
    return {
      ...state, image: payload.image, imgIndex: payload.imgIndex
    };
  case meetActionTypes.UPDATE_TEMP_VIRTUAL_BG:
    return {
      ...state, dupImage: payload.dupImage, dupImgIndex: payload.dupImgIndex
    };
  case meetActionTypes.UPDATE_VIRTUAL_TEMP:
    return {
      ...state, bodyPix: payload.bodyPix, tflite: payload.tflite
    };
  case meetActionTypes.UPDATE_VIRTUAL_TF:
    return {
      ...state, bodyPix: payload.bodyPix, tflite: payload.tflite
    };
  case meetActionTypes.UPDATE_VIRTUAL_STATUS:
    return {
      ...state, viewMode: payload.viewMode,peerConCheck:payload.peerConCheck
    };
    case meetActionTypes.UPDATE_PREVIOUS_VIEW_STATUS:
    return {
      ...state, previousView: payload.viewMode
    };
  default:
    return state;
  };
};
